/* eslint-disable no-unneeded-ternary */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable no-undef-init */
/* eslint-disable no-case-declarations */
/* eslint-disable dot-notation */
/* eslint-disable no-unused-expressions */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable no-shadow */
/* eslint-disable @typescript-eslint/no-empty-function */
/* eslint-disable no-else-return */
/* eslint-disable array-callback-return */
/* eslint-disable consistent-return */
/* eslint-disable react/jsx-key */
/* eslint-disable react/no-array-index-key */
/* eslint-disable no-param-reassign */
/* eslint-disable react/jsx-boolean-value */
/* eslint-disable object-shorthand */
/* eslint-disable camelcase */
/* eslint-disable no-nested-ternary */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, useCallback } from "react";

import {
  Box,
  List,
  ListSubheader,
  ListItem,
  Stack,
  useMediaQuery,
  Button,
  ListItemButton,
  Tooltip,
} from "@mui/material";

import SettingsIcon from "@mui/icons-material/Settings";
import ImageIcon from "@mui/icons-material/Image";
import { FormHandles } from "@unform/core";
import { Link } from "react-router-dom";
import VisibilityIcon from "@mui/icons-material/Visibility";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import { Form } from "@unform/web";
import { ItemText } from "../../../components/itemText";
import theme from "../../../theme";
import HeaderComp from "../../../components/header";
import { Container, TabelaDiv } from "./styles";
import { ArrayFilters } from "../../../interfaces/filterSearch";
import { useToast } from "../../../hooks/toast";
import { BannerTable } from "./Components/BannerTable";
import { useAuth } from "../../../hooks/auth";
import AccountsService from "../../../services/accounts";
import Loader from "../../../components/Loader";
import CoreService from "../../../services/core";
import Input from "../../../components/Input";
import FileInputSpecial from "./Components/FileInputSpecial";
import ModalImagem from "./Components/ModalImagem";

interface DadosFiltros {
  value: string;
  label: string;
}

const Settings: React.FC = () => {
  const { addToast } = useToast();
  const { signOut } = useAuth();
  const servicesacc = { AccountsService: new AccountsService() };
  const services = { coreServices: new CoreService() };

  const group = localStorage.getItem("@UserGroup:group");
  const groupParse = JSON.parse(group);

  console.log(groupParse);

  const pageSize = useMediaQuery("(max-width:1600px)");

  const [alertaOn, setAlertaOn] = React.useState<boolean>(false);
  const [alterarOn, setAlterarOn] = React.useState<boolean>(false);
  const [boolValues, setBoolValues] = React.useState<Record<string, boolean>>(
    {}
  );
  const [imgId, setImgId] = React.useState("");
  const [imgData, setImgData] = React.useState();
  const [isImg, setIsImg] = React.useState<boolean>(false);
  const [selectedQrCode, setSelectedQrCode] = React.useState<boolean>();
  const [selectedScape, setSelectedScape] = React.useState<boolean>();
  const [pedidoAlterado, setPedidoAlterado] = React.useState<boolean>(false);

  const [dadosBusca, setDadosBusca] = React.useState("");

  const [loading, setLoading] = useState<boolean>(true);
  const [page, setPage] = useState<number>(1);
  const [totalRows, setTotalRows] = useState<number>(0);
  const [descriptionValue, setDescriptionValue] = useState("");
  const [lastPage, setLastPage] = useState<number>(0);
  const [filters, setFilters] = useState<ArrayFilters>({
    filters: [{}],
  });
  const [allBanners, setAllBanners] = useState<any>();
  const [bannerFilter, setBannerFilter] = useState<any>([]);

  const siteType = localStorage.getItem("@Admin:siteType");

  const formRef = React.useRef<FormHandles>(null);

  const TabelaLabel = [
    {
      name: "CARD_VIRTUAL_ORDER_CLOSED",
      label: "Criar o pedido na tacom já com pagamento confirmado.",
    },
    {
      name: `CREATE_ORDER_IN_REQUEST`,
      label: 'Criar pedido na Tacom em "tempo real"',
      value:
        "Cria o pedido na Tacom assim que o pedido for realizado no BHBus.",
    },
    {
      name: `CREATE_QRCODE_TICKET_USE`,
      label: "Habilitar/Desabilizar Gerar QrCode(tempo real)",
    },
    {
      name: "CREATE_QRCODE_TICKET_USE_NOT_ALLOWED_ON_DAY",
      label: "Desativar Geração de QrCode por dia da semana",
      value:
        "0 - Segunda\n1 - Terça\n2 - Quarta\n3 - Quinta\n4 - Sexta\n5 - Sabado\n6 - Domingo",
    },
    {
      name: "MAINTENANCE_ALL_MODE",
      label: "O site fica em manutenção completamente.",
    },
    {
      name: "MAINTENANCE_AUTHENTICATED_MODE",
      label: "Manutenção somente para páginas autenticadas.",
    },
    {
      name: "NUMBER_BHBUS_ORDER_CAN_USE_CREDIT_CARD_BY_DAY",
      label: "Numero de recarga com cartão por cartão",
    },
    {
      name: "NUMBER_USER_CAN_USE_CREDIT_CARD_BY_DAY",
      label: "Numero de recargas com cartão por usuário",
    },
    {
      name: "PIX_EXPIRES_IN",
      label: "Tempo de Expiração do PIX(Segundos)",
    },
    {
      name: "IMAGE_FOR_EMAIL_SIGNATURE",
      label: "Logo Assinatura E-mail TRANSFÁCIL",
    },
    {
      name: "IMAGE_FOR_EMAIL_FOOTER",
      label: "Logo Rodapé E-mail TRANSFÁCIL",
    },
    {
      name: "LINK_REDIRECT_EMAIL_SIGNATURE",
      label: "Link de redirecionamento TRANSFÁCIL",
    },
    {
      name: "IMAGE_FOR_EMAIL_SIGNATURE_SETRA",
      label: "Logo Assinatura E-mail SETRA",
    },
    {
      name: "IMAGE_FOR_EMAIL_FOOTER_SETRA",
      label: "Logo Rodapé E-mail SETRA",
    },
    {
      name: "LINK_REDIRECT_EMAIL_SIGNATURE_SETRA",
      label: "Link de redirecionamento SETRA",
    },
    {
      name: "IMAGE_FOR_EMAIL_SIGNATURE_BHBUSMIDIA",
      label: "Logo Assinatura E-mail BHBUSMIDIA",
    },
    {
      name: "IMAGE_FOR_EMAIL_FOOTER_BHBUSMIDIA",
      label: "Logo Rodapé E-mail BHBUSMIDIA",
    },
    {
      name: "LINK_REDIRECT_EMAIL_SIGNATURE_BHBUSMIDIA",
      label: "Link de redirecionamento BHBUSMIDIA",
    },
  ];

  const getRechargeList = useCallback(async () => {
    setLoading(true);
    const response = await services.coreServices.getSettings();
    console.log(response?.data);
    const maping = response?.data?.results.filter((data: any) =>
      data?.value_type === "bool" && data?.name === "CREATE_QRCODE_TICKET_USE"
        ? setSelectedQrCode(data?.value)
        : data?.value_type === "bool" && data?.name === "SCAPE_SQS"
        ? setSelectedScape(data?.value)
        : ""
    );
    setAllBanners(response?.data);
    const filteringBanners = response?.data.results.filter(
      (data: any) =>
        data.name === "IMAGE_FOR_EMAIL_SIGNATURE" ||
        data.name === "IMAGE_FOR_EMAIL_FOOTER" ||
        data.name === "LINK_REDIRECT_EMAIL_SIGNATURE" ||
        data.name === "IMAGE_FOR_EMAIL_SIGNATURE_SETRA" ||
        data.name === "IMAGE_FOR_EMAIL_FOOTER_SETRA" ||
        data.name === "LINK_REDIRECT_EMAIL_SIGNATURE_SETRA" ||
        data.name === "IMAGE_FOR_EMAIL_SIGNATURE_BHBUSMIDIA" ||
        data.name === "IMAGE_FOR_EMAIL_FOOTER_BHBUSMIDIA" ||
        data.name === "LINK_REDIRECT_EMAIL_SIGNATURE_BHBUSMIDIA"
    );

    console.log(filteringBanners);
    setBannerFilter(filteringBanners);
    setTotalRows(response.data.count);
    const pages = response.data.count / 40;
    setLastPage(Math.ceil(pages));
    setTimeout(() => {
      setLoading(false);
    }, 100);
  }, [filters, dadosBusca]);

  const filteredFilters = filters.filters.filter(
    (item) => !item.hasOwnProperty("page")
  );

  const handleChangePerPage = useCallback(
    async (newPage: number) => {
      setPage(newPage);
      setFilters({ filters: [...filters.filters, { page: newPage }] });
    },
    [filters]
  );

  const handleCheckBoxChange = (name: string) => {
    setBoolValues((prev) => ({
      ...prev,
      [name]: !prev[name],
    }));
  };

  const ImagemID = (idalerta: any, version: any) => {
    setImgId(idalerta);
    setImgData(version);
    setIsImg(true);
  };

  const handleSubmit = useCallback(
    async (data) => {
      try {
        formRef.current?.setErrors({});
        const isMkt = groupParse?.map((dados: any) =>
          dados?.name === "Marketing" ? true : false
        );
        if (isMkt[0] === true) {
          const updatedBanners = bannerFilter.map((banner: any) => {
            const { id, name, value_type } = banner;

            let finalValue: any = banner.value;

            switch (value_type) {
              case "bool":
                finalValue = boolValues[name];
                break;

              case "int":
                finalValue = parseInt(data[`value_${id}`], 10);
                break;

              case "image":
                finalValue = banner.value;
                break;

              default:
                finalValue = data[`value_${id}`];
            }

            return {
              id,
              name,
              value_type,
              value: finalValue,
              description: data[`description_${id}`],
            };
          });

          await services.coreServices.patchSettings(updatedBanners);
          setTimeout(() => {
            window.location.reload();
          }, 2000);
        } else {
          const updatedBanners = allBanners.results.map((banner: any) => {
            const { id, name, value_type } = banner;

            let finalValue: any = banner.value;

            switch (value_type) {
              case "bool":
                finalValue = boolValues[name];
                break;

              case "int":
                finalValue = parseInt(data[`value_${id}`], 10);
                break;

              case "image":
                finalValue = banner.value;
                break;

              default:
                finalValue = data[`value_${id}`];
            }

            return {
              id,
              name,
              value_type,
              value: finalValue,
              description: data[`description_${id}`],
            };
          });

          await services.coreServices.patchSettings(updatedBanners);
          setTimeout(() => {
            window.location.reload();
          }, 2000);
        }
        addToast({
          type: "success",
          title: "Settings atualizado.",
          description: "Dados atualizados com sucesso.",
        });
        // window.location.reload();
      } catch (err) {
        console.error(err);

        addToast({
          type: "error",
          title: "Erro ao enviar formulário.",
          description: "Verifique os campos e tente novamente.",
        });
      }
    },
    [addToast, allBanners, boolValues]
  );

  useEffect(() => {
    getRechargeList();
  }, [page, filters]);

  useEffect(() => {
    const handleBeforeUnload = (event: BeforeUnloadEvent) => {
      localStorage.removeItem("RecargaStatus");

      // Exemplo: salvar dados no localStorage antes de sair
      localStorage.setItem("lastVisit", new Date().toISOString());
    };

    window.addEventListener("beforeunload", handleBeforeUnload);

    // Remover o listener quando o componente é desmontado
    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, []);

  useEffect(() => {}, [dadosBusca, filters, filteredFilters, dadosBusca]);

  useEffect(() => {
    if (pedidoAlterado) {
      getRechargeList();
      setPedidoAlterado(false);
    }
  }, [pedidoAlterado]);

  useEffect(() => {}, [selectedQrCode, selectedScape]);

  React.useEffect(() => {
    const initialBools = allBanners?.results
      .filter((item: any) => item.value_type === "bool")
      .reduce((acc: Record<string, boolean>, curr: any) => {
        acc[curr.name] = curr.value;
        return acc;
      }, {});

    setBoolValues(initialBools);
  }, [allBanners]);

  return (
    <>
      {loading ? (
        <Loader />
      ) : (
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
          }}
        >
          <HeaderComp filtroNaparece={true} />
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              margin: 0,
            }}
          >
            <Box sx={{ display: "flex", flexGrow: 1 }}>
              <Box sx={{ flexGrow: 1, textAlign: "center" }}>
                <Container>
                  <List
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      margin: 2,
                      justifyContent: "center",
                    }}
                  >
                    <Box
                      sx={{
                        backgroundColor: "RGB(248, 248, 248)",
                        borderRadius: 4,
                        boxShadow: "2px 2px 4px rgba(0, 0, 0, 0.3)",
                        overflowX: "auto",
                        display: "grid",
                      }}
                    >
                      <Stack
                        sx={{
                          zIndex: 0,
                        }}
                      >
                        <ListSubheader
                          sx={{
                            width: "100%",
                            textAlign: "center",
                            fontWeight: "bold",
                            marginTop: "10px",
                            backgroundColor: "RGB(248, 248, 248)",
                          }}
                        >
                          <Box>
                            <ItemText
                              primary="Configurações"
                              hideSecondary
                              primarySx={{
                                color: theme.palette.secondary.main,
                                fontSize: pageSize ? "30px" : "20px",
                                fontWeight: "bold",
                              }}
                            />
                          </Box>
                        </ListSubheader>
                      </Stack>
                      <Form
                        ref={formRef}
                        onSubmit={handleSubmit}
                        initialData={allBanners.results?.name}
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          flexDirection: "column",
                        }}
                      >
                        {!loading && (
                          <TabelaDiv className="Tabela">
                            {groupParse?.map((dados: any) =>
                              dados?.name === "Marketing" ? (
                                <BannerTable
                                  data={bannerFilter}
                                  columns={[
                                    {
                                      name: <div>ID</div>,
                                      selector: "id",
                                      cell: ({ id }: any) => (
                                        <div className="specifitcell">{id}</div>
                                      ),
                                    },
                                    {
                                      name: <div>Nome</div>,
                                      selector: "name",
                                      cell: ({ name }: any) => (
                                        <div className="specifitcell">
                                          {name === "IMAGE_FOR_EMAIL_SIGNATURE"
                                            ? "Logo Assinatura E-mail TRANSFÁCIL"
                                            : name === "IMAGE_FOR_EMAIL_FOOTER"
                                            ? "Logo Rodapé E-mail TRANSFÁCIL"
                                            : name ===
                                              "LINK_REDIRECT_EMAIL_SIGNATURE"
                                            ? "Link de redirecionamento TRANSFÁCIL"
                                            : name ===
                                              "IMAGE_FOR_EMAIL_SIGNATURE_SETRA"
                                            ? "Logo Assinatura E-mail SETRA"
                                            : name ===
                                              "IMAGE_FOR_EMAIL_FOOTER_SETRA"
                                            ? "Logo Rodapé E-mail SETRA"
                                            : name ===
                                              "LINK_REDIRECT_EMAIL_SIGNATURE_SETRA"
                                            ? "Link de redirecionamento SETRA"
                                            : name ===
                                              "IMAGE_FOR_EMAIL_SIGNATURE_BHBUSMIDIA"
                                            ? "Logo Assinatura E-mail BHBUSMIDIA"
                                            : name ===
                                              "IMAGE_FOR_EMAIL_FOOTER_BHBUSMIDIA"
                                            ? "Logo Rodapé E-mail BHBUSMIDIA"
                                            : name ===
                                              "LINK_REDIRECT_EMAIL_SIGNATURE_BHBUSMIDIA"
                                            ? "Link de redirecionamento BHBUSMIDIA"
                                            : name}
                                        </div>
                                      ),
                                    },
                                    {
                                      name: <div>Descrição</div>,
                                      selector: "description",
                                      cell: ({
                                        description,
                                        id,
                                        name,
                                      }: any) => (
                                        <div className="specifitcell">
                                          <Input
                                            id={`description_${id}`}
                                            name={`description_${id}`}
                                            defaultValue={description}
                                          />
                                        </div>
                                      ),
                                    },
                                    {
                                      name: <div>Valor</div>,
                                      selector: "action",
                                      cell: ({
                                        id,
                                        value,
                                        value_type,
                                        name,
                                      }: any) => (
                                        <Stack
                                          sx={{
                                            display: "flex",
                                            flexDirection: "row",
                                            justifyContent: "space-evenly",
                                          }}
                                        >
                                          {value_type === "bool" ? (
                                            <Tooltip
                                              title={
                                                boolValues[name]
                                                  ? "Deseja Desativar?"
                                                  : "Deseja Ativar?"
                                              }
                                              onClick={() =>
                                                handleCheckBoxChange(name)
                                              }
                                            >
                                              {boolValues[name] ? (
                                                <CheckBoxIcon className="iconCheck" />
                                              ) : (
                                                <CheckBoxOutlineBlankIcon className="iconCheck" />
                                              )}
                                            </Tooltip>
                                          ) : value_type === "image" ? (
                                            <Tooltip
                                              title="Alterar Imagem?"
                                              onClick={() => ImagemID(id, name)}
                                            >
                                              <ImageIcon className="iconDelete" />
                                            </Tooltip>
                                          ) : (
                                            <div>
                                              <Input
                                                id={`value_${id}`}
                                                name={`value_${id}`}
                                                defaultValue={value}
                                              />
                                            </div>
                                          )}
                                        </Stack>
                                      ),
                                    },
                                  ]}
                                />
                              ) : (
                                <BannerTable
                                  data={allBanners.results}
                                  columns={[
                                    {
                                      name: <div>ID</div>,
                                      selector: "id",
                                      cell: ({ id }: any) => (
                                        <div className="specifitcell">{id}</div>
                                      ),
                                    },
                                    {
                                      name: <div>Nome</div>,
                                      selector: "name",
                                      cell: ({ name }: any) => {
                                        // Busca o objeto dentro do array TabelaLabel onde o 'name' coincide
                                        const itemEncontrado = TabelaLabel.find(
                                          (item) => item.name === name
                                        );
                                        const textoTooltip =
                                          itemEncontrado && itemEncontrado.value
                                            ? itemEncontrado.value
                                            : "";

                                        return (
                                          <div
                                            className="specifitcell"
                                            title={textoTooltip} // Aqui é onde a mágica do hover acontece
                                            style={{
                                              cursor: textoTooltip
                                                ? "help"
                                                : "default",
                                            }} // Opcional: muda o cursor para indicar que tem ajuda
                                          >
                                            {/* Se encontrou o item, mostra a label, senão mostra o name original */}
                                            {itemEncontrado
                                              ? itemEncontrado.label
                                              : name}
                                          </div>
                                        );
                                      },
                                    },
                                    {
                                      name: <div>Descrição</div>,
                                      selector: "description",
                                      cell: ({
                                        description,
                                        id,
                                        name,
                                      }: any) => (
                                        <div className="specifitcell">
                                          <Input
                                            id={`description_${id}`}
                                            name={`description_${id}`}
                                            defaultValue={description}
                                          />
                                        </div>
                                      ),
                                    },
                                    {
                                      name: <div>Valor</div>,
                                      selector: "action",
                                      cell: ({
                                        id,
                                        value,
                                        value_type,
                                        name,
                                      }: any) => (
                                        <Stack
                                          sx={{
                                            display: "flex",
                                            flexDirection: "row",
                                            justifyContent: "space-evenly",
                                          }}
                                        >
                                          {value_type === "bool" ? (
                                            <Tooltip
                                              title={
                                                boolValues[name]
                                                  ? "Deseja Desativar?"
                                                  : "Deseja Ativar?"
                                              }
                                              onClick={() =>
                                                handleCheckBoxChange(name)
                                              }
                                            >
                                              {boolValues[name] ? (
                                                <CheckBoxIcon className="iconCheck" />
                                              ) : (
                                                <CheckBoxOutlineBlankIcon className="iconCheck" />
                                              )}
                                            </Tooltip>
                                          ) : value_type === "image" ? (
                                            <Tooltip
                                              title="Alterar Imagem?"
                                              onClick={() => ImagemID(id, name)}
                                            >
                                              <ImageIcon className="iconDelete" />
                                            </Tooltip>
                                          ) : (
                                            <div>
                                              <Input
                                                id={`value_${id}`}
                                                name={`value_${id}`}
                                                defaultValue={value}
                                              />
                                            </div>
                                          )}
                                        </Stack>
                                      ),
                                    },
                                  ]}
                                />
                              )
                            )}
                          </TabelaDiv>
                        )}
                        <Button
                          type="submit"
                          sx={{
                            backgroundColor: "var(--purple)",
                            color: "white",
                            ":hover": {
                              color: "var(--orange)",
                              fontWeight: "bold",
                            },
                          }}
                        >
                          Salvar
                        </Button>
                      </Form>
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "center",
                          marginTop: 2,
                          marginBottom: 2,
                          fontWeight: "bold",
                        }}
                      >
                        <Button
                          disabled={allBanners?.previous === null}
                          onClick={() => handleChangePerPage(1)}
                          sx={{
                            backgroundColor: theme.palette.primary.main,
                            margin: 1,
                            color: "white",
                          }}
                        >
                          Primeira Página
                        </Button>
                        <Button
                          disabled={allBanners?.previous === null}
                          onClick={() => handleChangePerPage(page - 1)}
                          sx={{
                            backgroundColor: theme.palette.secondary.main,
                            margin: 1,
                            color: "white",
                          }}
                        >
                          Anterior
                        </Button>
                        <Box
                          sx={{ margin: 2 }}
                        >{`Página ${page} de ${lastPage}`}</Box>
                        <Button
                          disabled={allBanners?.next === null}
                          onClick={() => handleChangePerPage(page + 1)}
                          sx={{
                            backgroundColor: theme.palette.secondary.main,
                            margin: 1,
                            color: "white",
                          }}
                        >
                          Próxima
                        </Button>
                        <Button
                          disabled={allBanners?.next === null}
                          onClick={() => handleChangePerPage(lastPage)}
                          sx={{
                            backgroundColor: theme.palette.primary.main,
                            margin: 1,
                            color: "white",
                          }}
                        >
                          Última Página
                        </Button>
                      </Box>
                    </Box>
                  </List>
                </Container>
              </Box>
            </Box>
          </Box>
          {isImg && (
            <ModalImagem
              open={isImg}
              handleClose={() => setIsImg(false)}
              id={imgId}
            />
          )}
        </Box>
      )}
    </>
  );
};

export default Settings;
